export default {
  'common.balance.title': 'Số dư',
  'common.balance.coinName': 'Xu',
  'common.balance.startName': 'Sao',
  'common.search.noResult': 'Không có kết quả...',
  'common.search.search': 'Tìm kiếm...',
  'common.form.required': 'Trường này là bắt buộc',

  'header.user.colorSchemeDark': 'Tối',
  'header.user.colorSchemeLight': 'Sáng',
  'header.user.logOut': 'Đăng xuất',
  'header.user.settings': 'Cài đặt',

  'profile.settings': 'Cài đặt hồ sơ',
  'profile.selectRegion': 'Chọn khu vực của bạn',
  'profile.regionSelectionNotice': 'Vui lòng chọn đúng khu vực. Không thể thay đổi sau này',
  'profile.regionSelectionWarning': 'Không thể thay đổi sau này',
  'profile.save': 'Lưu',
  'profile.saveSuccess': 'Hồ sơ của bạn đã được lưu thành công',

  'theme.settings': 'Cài đặt giao diện',
  'theme.view': 'Danh sách giao diện',
  'theme.saveAsNew': 'Hoặc lưu thành giao diện mới',
  'theme.save': 'Lưu thay đổi',
  'theme.placeholder': 'Tên giao diện',
  'theme.noThemeSelected': 'Chưa chọn giao diện. Bạn có thể thêm giao diện mới hoặc chọn giao diện có sẵn',

  'data.saveSuccess': 'Lưu dữ liệu thành công',
  'data.deleteSuccess': 'Xóa thành công',

  // Free Fire Companion translations
  'ff.brand': 'Free Fire Companion',

  // Navigation
  'ff.nav.hot': 'Hot',
  'ff.nav.items': 'Vật phẩm',
  'ff.nav.outfits': 'Trang phục',
  'ff.nav.guns': 'Súng',
  'ff.nav.collections': 'Bộ sưu tập',
  'ff.nav.collectibility': 'Sưu tầm',
  'ff.nav.tools': 'Công cụ',
  'ff.nav.profile': 'Hồ sơ',
  'ff.nav.skillCombos': 'Combo Kỹ Năng',
  'ff.nav.more': 'Thêm',
  'ff.nav.playstyles': 'Lối chơi',

  // Tabs
  'ff.tabs.mostLoved': 'Yêu thích nhất',
  'ff.tabs.recent': 'Gần đây',
  'ff.tabs.hot': 'Hot',
  'ff.tabs.rank': 'Độ phổ biến',
  'ff.tabs.trending': 'Thịnh hành',
  'ff.tabs.wishlist': 'Yêu thích',
  'ff.tabs.like7d': 'Hot 7 ngày',
  'ff.tabs.like30d': 'Hot 30 ngày',

  // Rarity
  'ff.rarity.mythic': 'Huyền thoại tối thượng',
  'ff.rarity.legendary': 'Huyền thoại',
  'ff.rarity.epic': 'Sử thi',
  'ff.rarity.rare': 'Hiếm',
  'ff.rarity.common': 'Thường',

  'ff.popularity.title': 'Độ phổ biến',

  // Actions
  'ff.action.like': 'Thích',
  'ff.action.favorite': 'Yêu thích',
  'ff.action.viewDetails': 'Xem chi tiết',
  'ff.action.share': 'Chia sẻ',
  'ff.action.close': 'Đóng',

  // Search & Filter
  'ff.search.placeholder': 'Tìm kiếm vật phẩm...',
  'ff.search.filterByRarity': 'Lọc theo độ hiếm',
  'ff.search.filterByCategory': 'Lọc theo danh mục',
  'ff.search.filterByGenre': 'Lọc theo thể loại',
  'ff.search.allCategories': 'Tất cả danh mục',
  'ff.search.allRarities': 'Tất cả độ hiếm',
  'ff.search.allGenres': 'Tất cả thể loại',
  'ff.search.results': 'kết quả',

  // Profile
  'ff.profile.level': 'Cấp độ',
  'ff.profile.favorites': 'Yêu thích',
  'ff.profile.statistics': 'Thống kê',
  'ff.profile.totalLikes': 'Tổng lượt thích',
  'ff.profile.itemsCollected': 'Vật phẩm đã sưu tập',

  // Event
  'ff.event.featured': 'Sự kiện nổi bật',
  'ff.event.endsIn': 'Kết thúc sau',
  'ff.event.viewEvent': 'Xem sự kiện',

  // Tools
  'ff.tools.sensitivityCalc': 'Máy tính độ nhạy',
  'ff.tools.sensitivityCalcDesc': 'Tìm cài đặt độ nhạy ngắm hoàn hảo',
  'ff.tools.damageCalc': 'Máy tính sát thương',
  'ff.tools.damageCalcDesc': 'Tính sát thương vũ khí và so sánh chỉ số',
  'ff.tools.dropCalc': 'Máy tính rơi đồ',
  'ff.tools.dropCalcDesc': 'Tìm vị trí rơi đồ tốt nhất',

  // Tool Pages
  'ff.tools.marketplace': 'Chợ',
  'ff.tools.marketplace.search': 'Tìm kiếm chợ...',
  'ff.tools.marketplace.seller': 'Người bán',
  'ff.tools.marketplace.buy': 'Mua',

  'ff.tools.tactical': 'Bản đồ chiến thuật',
  'ff.tools.tactical.search': 'Tìm điểm đáp...',
  'ff.tools.tactical.map': 'Bản đồ',
  'ff.tools.tactical.rank': 'Hạng',
  'ff.tools.tactical.landingRate': 'Tỷ lệ đáp %',

  'ff.tools.combo': 'Thống kê combo nhân vật',
  'ff.tools.combo.role': 'Vai trò',
  'ff.tools.combo.winRate': 'Tỷ lệ thắng',
  'ff.tools.combo.pickRate': 'Tỷ lệ chọn',
  'ff.tools.combo.sample': 'Mẫu',

  'ff.tools.gunSkins': 'Danh sách skin súng',
  'ff.tools.gunSkins.class': 'Hạng',
  'ff.tools.gunSkins.weapon': 'Vũ khí',
  'ff.tools.gunSkins.equipRate': 'Tỷ lệ trang bị',

  // Item Details
  'ff.item.stats': 'Chỉ số',
  'ff.item.description': 'Mô tả',
  'ff.item.relatedItems': 'Vật phẩm liên quan',
  'ff.item.likes': 'lượt thích',

  // Collections
  'ff.collections.progress': 'Tiến độ',
  'ff.collections.complete': 'Hoàn thành',
  'ff.collections.items': 'vật phẩm',
  'ff.collections.skill': 'Kỹ năng',
  'ff.collections.cooldown': 'Hồi chiêu',
  'ff.collections.skillType.active': 'Chủ động',
  'ff.collections.skillType.passive': 'Bị động',

  'ff.list.noItems': 'Không tìm thấy vật phẩm',
  'ff.profile.title': 'Hồ sơ',
  'ff.profile.primeLevel': 'Cấp Prime',
  'ff.profile.collections': 'Bộ sưu tập',
  'ff.profile.currentSeason': 'Mùa hiện tại',
  'ff.profile.noData': 'Không có dữ liệu hồ sơ',

  'ff.item.stats.damage': 'Sát thương',
  'ff.item.stats.accuracy': 'Độ chính xác',
  'ff.item.stats.range': 'Tầm bắn',
  'ff.item.stats.speed': 'Tốc độ bắn',
  'ff.item.stats.reload': 'Nạp đạn',
  'ff.item.stats.cartridge': 'Ống đạn',
  'ff.item.stats.biteArmor': 'Xuyên giáp',
  'ff.item.stats.playerSpeedFactor': 'Tốc độ di chuyển',

  // Shortened stat labels for item cards
  'ff.item.stats.short.damage': 'DMG',
  'ff.item.stats.short.accuracy': 'ACC',
  'ff.item.stats.short.range': 'RNG',
  'ff.item.stats.short.speed': 'ROF',
  'ff.item.stats.short.reload': 'RLD',
  'ff.item.stats.short.cartridge': 'MAG',
  'ff.item.stats.short.biteArmor': 'PEN',
  'ff.item.stats.short.playerSpeedFactor': 'MOV',

  'ff.action.removeFromCompare': 'Bỏ khỏi so sánh',
  'ff.action.compareListFull': 'Danh sách so sánh đầy (tối đa 3)',
  'ff.action.addToCompare': 'Thêm vào so sánh',
  'ff.action.compareHint': 'Vui lòng thêm 1 khẩu súng nữa để so sánh',

  'ff.list.noMore': 'Hết vật phẩm',
  'ff.item.setContents': 'Nội dung bộ',
  'ff.item.weaponStats': 'Chỉ số vũ khí',

  'ff.pageNotFound.title': 'Không tìm thấy trang',
  'ff.pageNotFound.backToHome': 'Về trang chủ',

  'ff.popularity.among': 'TRONG',
  'ff.popularity.allItems': 'TẤT CẢ VẬT PHẨM',

  'ff.filter.title': 'Bộ lọc',
  'ff.filter.all': 'Tất cả',
  'ff.filter.allGenres': 'Tất cả thể loại',
  'ff.filter.allWeapons': 'Tất cả vũ khí',

  'ff.tags.powerType': 'Tăng sức mạnh',

  'ff.item.owned': 'Đã có',

  'ff.search.filterByWeapon': 'Lọc theo vũ khí',
  'ff.search.allWeapons': 'Tất cả vũ khí',

  // Collectibility
  'ff.collectibility.title': 'Kho sưu tầm Free Fire',
  'ff.collectibility.outfits': 'Trang phục',
  'ff.collectibility.gunSkins': 'Skin súng',
  'ff.collectibility.collections': 'Bộ sưu tập',
  'ff.collectibility.owned': 'Đã có',
  'ff.collectibility.points': 'Điểm',
  'ff.collectibility.uid': 'Uid',
  'ff.collectibility.name': 'Tên',
  'ff.collectibility.score': 'Điểm',
  'ff.collectibility.back': 'Quay lại',
  'ff.collectibility.detail.category': 'Hạng mục',
  'ff.collectibility.detail.itemOwned': 'Vật phẩm sở hữu',
  'ff.collectibility.detail.pointScore': 'Điểm số',
  'ff.collectibility.rank': 'Hạng',

  // Collectibity (wardrobe page)
  'ff.collectibity.title': 'Tủ Đồ Của Bạn',
  'ff.collectibity.collectorProfile': 'Hồ Sơ Người Sưu Tầm',
  'ff.collectibity.totalItems': 'Số Vật Phẩm',
  'ff.collectibity.totalValue': 'Tổng Giá Trị',
  'ff.collectibity.rankLabel': 'Hạng',
  'ff.collectibity.rankDetails': 'Chi Tiết Cấp',
  'ff.collectibity.yourScore': 'Điểm của bạn',
  'ff.collectibity.filterBtn': 'Bộ Lọc',
  'ff.collectibity.viewItems': 'Xem Vật Phẩm',
  'ff.collectibity.category.collection': 'Bộ Sưu Tập',
  'ff.collectibity.category.fashion': 'Thời Trang',
  'ff.collectibity.category.guns': 'Súng',
  'ff.collectibity.sub.exhibition': 'Thẻ Hiệm',
  'ff.collectibity.sub.activity': 'Hoạt Động',
  'ff.collectibity.sub.event': 'Sự Kiện',
  'ff.collectibity.sub.ranking': 'Bảng Xếp Hạng',
  'ff.collectibity.sub.shirt': 'Áo',
  'ff.collectibity.sub.swimwear': 'Bơi Mảnh',
  'ff.collectibity.sub.pants': 'Quần',
  'ff.collectibity.sub.shoes': 'Giày',
  'ff.collectibity.sub.head': 'Đầu',
  'ff.collectibity.sub.mask': 'Mặt Nạ',
  'ff.collectibity.sub.facepaint': 'Vẽ Mặt',
  'ff.collectibity.sub.bundle': 'Gói Trang Phục',
  'ff.collectibity.sub.assault': 'Súng Trường',
  'ff.collectibity.sub.shotgun': 'Shotgun',
  'ff.collectibity.sub.smg': 'Tiểu Liên',
  'ff.collectibity.sub.sniper': 'Súng Tỉa',
  'ff.collectibity.sub.lmg': 'Súng Máy',
  'ff.collectibity.sub.marksman': 'Súng Ngắm',
  'ff.collectibity.sub.launcher': 'Súng Khác',
  'ff.collectibity.sub.pistol': 'Súng Lục',
  'ff.collectibity.maxRankReached': 'Đã đạt hạng tối đa',
  'ff.collectibity.needMore': 'Cần thêm',
  'ff.collectibity.moreToReach': 'để đạt',
  'ff.collectibity.yourRank': 'Hạng Của Bạn',
  'ff.collectibity.viewDetail': 'Xem Chi Tiết',
  'ff.collectibity.friends': 'Bạn Bè',
  'ff.collectibity.server': 'Máy Chủ',
  'ff.collectibity.rankHeader': 'Xếp Hạng',
  'ff.collectibity.nameHeader': 'Tên',
  'ff.collectibity.itemsCount': 'Số Vật Phẩm',
  'ff.collectibity.valueScore': 'Giá Trị',
  'ff.collectibity.you': 'Bạn',
  'ff.collectibity.yourRankLabel': 'Hạng Của Bạn',

  // Skill Combos
  'ff.skillCombos.title': 'Combo Kỹ Năng',
  'ff.skillCombos.tabBR': 'Battle Royale',
  'ff.skillCombos.tabCS': 'Clash Squad',
  'ff.skillCombos.recentPlaystyle': 'Phong Cách Chơi Gần Đây',
  'ff.skillCombos.favoriteRole': 'Vai Trò Yêu Thích',
  'ff.skillCombos.longRange': 'Tầm Xa',
  'ff.skillCombos.shortRange': 'Tầm Ngắn',
  'ff.skillCombos.currentCombo': 'Combo Hiện Tại',
  'ff.skillCombos.suggested': 'Gợi Ý',
  'ff.skillCombos.allSkills': 'Tất cả kỹ năng',
  'ff.skillCombos.passiveOnly': 'Chỉ kỹ năng bị động',
  'ff.skillCombos.comboFilters': 'Bộ Lọc Combo',
  'ff.skillCombos.character': 'Nhân Vật',
  'ff.skillCombos.matchMode': 'Chế Độ Khớp',
  'ff.skillCombos.matchAll': 'Khớp tất cả',
  'ff.skillCombos.matchAny': 'Khớp bất kỳ',
  'ff.skillCombos.searchCharacter': 'Tìm kiếm theo tên nhân vật',
  'ff.skillCombos.noCharactersFound': 'Không tìm thấy',
  'ff.skillCombos.role': 'Vai Trò',
  'ff.skillCombos.hasActiveSkill': 'Có kỹ năng chủ động',
  'ff.skillCombos.yes': 'Có',
  'ff.skillCombos.no': 'Không',
  'ff.skillCombos.difficulty': 'Độ Khó',
  'ff.skillCombos.teamSize': 'Kích Thước Đội',
  'ff.skillCombos.topCombosBR': 'Combo Hàng Đầu - Battle Royale',
  'ff.skillCombos.topCombosCS': 'Combo Hàng Đầu - Clash Squad',
  'ff.skillCombos.updatedEveryPatch': 'Cập nhật mỗi bản vá',
  'ff.skillCombos.comboName': 'Tên Combo',
  'ff.skillCombos.comboDetails': 'Chi Tiết Combo',
  'ff.skillCombos.usage': 'Tỷ lệ dùng',
  'ff.skillCombos.brTop': 'Top BR',
  'ff.skillCombos.csBooyah': 'CS Booyah',
  'ff.skillCombos.winRate': 'Tỷ Lệ Thắng',
  'ff.skillCombos.noResults': 'Không tìm thấy combo nào',
  'ff.skillCombos.noMore': 'Không còn combo nào khác',
  'ff.skillCombos.faqTitle': 'Hệ Thống Kỹ Năng',
  'ff.skillCombos.faqSlots': 'Mỗi người chơi có 4 ô kỹ năng',
  'ff.skillCombos.faqOption1Title': '1 Chủ Động + 3 Bị Động',
  'ff.skillCombos.faqOption2Title': '4 Bị Động',
  'ff.skillCombos.faqTip': 'Người mới nên bắt đầu với 1 Chủ Động + 3 Bị Động.',
  'ff.skillCombos.comboFaqTitle': 'Câu Hỏi Thường Gặp',
  'ff.skillCombos.faqHtml': '<p>Combo được xếp hạng theo tỷ lệ thắng dựa trên 4 ô kỹ năng đã trang bị. Lọc theo vai trò, độ khó hoặc yêu cầu kỹ năng chủ động để tìm combo phù hợp với lối chơi của bạn.</p>',

  // Characters
  'ff.characters.title': 'Kỹ Năng',
  'ff.nav.characters': 'Nhân Vật',
  'ff.characters.tabActive': 'Chủ Động',
  'ff.characters.tabPassive': 'Bị Động',
  'ff.characters.filter': 'Lọc',
  'ff.characters.sort': 'Sắp Xếp',
  'ff.characters.searchPlaceholder': 'Tìm kiếm nhân vật...',
  'ff.characters.filterRole': 'Vai Trò',
  'ff.characters.filterDifficulty': 'Độ Khó',
  'ff.characters.resetFilters': 'Đặt lại bộ lọc',
  'ff.characters.roleAll': 'Tất Cả',
  'ff.characters.roleTeam': 'Đội',
  'ff.characters.roleSurvival': 'Sinh Tồn',
  'ff.characters.roleOffense': 'Tấn Công',
  'ff.characters.roleIntel': 'Trinh Sát',
  'ff.characters.difficultyEasy': 'Dễ',
  'ff.characters.difficultyMedium': 'Trung Bình',
  'ff.characters.difficultyHard': 'Khó',
  'ff.characters.sortBy': 'Sắp Xếp Theo',
  'ff.characters.sortNameAZ': 'Tên (A→Z)',
  'ff.characters.sortNameZA': 'Tên (Z→A)',
  'ff.characters.sortDifficultyEH': 'Độ Khó (Dễ→Khó)',
  'ff.characters.sortDifficultyHE': 'Độ Khó (Khó→Dễ)',
  'ff.characters.sortTopRateHL': 'Tỉ Lệ Top (Cao→Thấp)',
  'ff.characters.sortPickRateHL': 'Tỉ Lệ Chọn (Cao→Thấp)',
  'ff.characters.brTopRate': 'Tỉ Lệ Top BR',
  'ff.characters.pickRate': 'Tỉ Lệ Chọn',
  'ff.characters.skillType.active': 'Chủ Động',
  'ff.characters.skillType.passive': 'Bị Động',
  'ff.characters.top3Pairings': 'Top 3 Kết Hợp',
  'ff.characters.top10Synergy': 'Top 10 Cộng Hưởng',
  'ff.characters.synergySkill': 'Kỹ Năng',
  'ff.characters.synergyBRTop': 'Top BR',
  'ff.characters.synergyCSTop': 'Top CS',
  'ff.characters.metricBR': 'BR',
  'ff.characters.metricCS': 'CS',
  'ff.characters.synergyPickRate': 'Tỉ Lệ Chọn',
  'ff.characters.noResults': 'Không tìm thấy nhân vật',

  // Report
  'ff.report.title': 'Báo cáo vật phẩm',
  'ff.report.description': 'Vui lòng chọn lý do báo cáo vật phẩm này.',
  'ff.report.categoryLabel': 'Lý do báo cáo',
  'ff.report.contentLabel': 'Chi tiết bổ sung',
  'ff.report.contentPlaceholder': 'Mô tả vấn đề chi tiết hơn (không bắt buộc)...',
  'ff.report.submit': 'Gửi báo cáo',
  'ff.report.submitSuccess': 'Báo cáo đã được gửi thành công',
  'ff.report.submitError': 'Gửi báo cáo thất bại',
  'ff.report.categoryLimit': 'Bạn chỉ có thể chọn tối đa 3 lý do',
}
